// extracted by mini-css-extract-plugin
module.exports = {"Stars":"Star_Stars__z-lao","Fill":"Star_Fill__fc_Od","Empty":"Star_Empty__RNluf"};